import { useI18n } from '../../../shared/i18n';
import { localePath } from '../../../shared/i18n/routing';
import type { PublicAsset } from '../../../shared/lib';
import { Avatar } from '../../../shared/ui';
import type { PublicMember } from '../publicApi';

export interface TeamCardProps {
  member: PublicMember;
  /** Resolved separately — `photo_media_id` has no server-side resolution. */
  photo: PublicAsset | undefined;
}

export function TeamCard({ member, photo }: TeamCardProps) {
  const { locale, t } = useI18n();

  return (
    <a
      href={localePath(locale, `/team/${member.slug}`)}
      className="hs-card flex flex-col items-center gap-3 rounded-lg p-6 text-center transition-all duration-[--hs-duration-base] ease-out hover:-translate-y-0.5 hover:border-accent/40 hover:shadow-md"
    >
      <Avatar name={member.name} src={photo?.url} size="lg" className="size-24 text-2xl" />
      <div>
        <p className="font-medium text-text">{member.name}</p>
        <p className="text-sm text-accent">{member.position}</p>
        {member.experience_years !== null ? (
          <p className="hs-meta mt-1 text-text-subtle">
            {t('common.team.yearsExperience', { years: member.experience_years })}
          </p>
        ) : null}
      </div>
    </a>
  );
}
